var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.sidebar-fields",
                    modifiers: { "sidebar-fields": true }
                  }
                ],
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "table-settings" }
              },
              [_c("v-icon", { attrs: { name: "buttons/cog", size: 13 } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "table-settings",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [_vm._v("\n        Колонки\n      ")]
            ),
            _vm._v(" "),
            _vm.canEditResponses()
              ? _c(
                  "b-btn",
                  {
                    staticClass: "custom-btn-primary",
                    attrs: { disabled: _vm.isBusy },
                    on: {
                      click: function($event) {
                        return _vm.showModal(null, false)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                    _vm._v("\n        Новый отклик\n      ")
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          _c(
            "div",
            { staticClass: "page-filters" },
            [
              _c(
                "filters-drawer",
                {
                  attrs: {
                    query: _vm.filters.query,
                    "is-busy": _vm.isBusy,
                    "filter-tags": _vm.activeFilterTags
                  },
                  on: {
                    "update:query": function($event) {
                      return _vm.$set(_vm.filters, "query", $event)
                    },
                    "remove-tag": _vm.removeFilterTag,
                    submit: _vm.onSearch,
                    clear: _vm.onClearFilters
                  }
                },
                [
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Объявления")
                      ]),
                      _vm._v(" "),
                      _c("recruit-job-posting-select", {
                        ref: "recruit_job_posting_select",
                        attrs: {
                          title: "id объявления",
                          value: _vm.filters.job_posting_id
                        },
                        on: { onSelect: _vm.onSelectJobPosting }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Заявка на подбор")
                      ]),
                      _vm._v(" "),
                      _c("recruit-task-select", {
                        ref: "recruit_task_select",
                        attrs: { value: _vm.filters.recruit_task_id },
                        on: { onSelect: _vm.onSelectRecruitTask }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("ID исполнителя")
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: {
                          id: "input-response-worker-id",
                          type: "number",
                          min: "1",
                          step: "1",
                          size: "sm",
                          placeholder: "Введите ID исполнителя"
                        },
                        model: {
                          value: _vm.filters.worker_id,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "worker_id", _vm._n($$v))
                          },
                          expression: "filters.worker_id"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Статус")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          id: "input-response-status",
                          size: "sm",
                          options: _vm.statusOptions
                        },
                        model: {
                          value: _vm.filters.status,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Ответственные")
                      ]),
                      _vm._v(" "),
                      _c("user-multi-select", {
                        ref: "user_multi_select_assigned",
                        attrs: {
                          id: "user-multi-select-assigned",
                          title: "Ответственные"
                        },
                        on: { onSelect: _vm.onSelectUserAssigned }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBusy || (_vm.items && _vm.items.length > 0)
            ? [
                _c(
                  "div",
                  { staticClass: "page-table-container" },
                  [
                    _vm.viewMode === "table"
                      ? _c("b-table", {
                          ref: "job_posting_responses",
                          staticClass: "custom-table mb-0 text-small",
                          attrs: {
                            id: "job-posting-responses",
                            "sticky-header": "",
                            selectable: "",
                            "select-mode": "single",
                            responsive: "",
                            busy: _vm.isBusy,
                            items: _vm.items,
                            fields: _vm.renderedFields,
                            "no-provider-filtering": "",
                            "no-provider-paging": "",
                            "no-provider-sorting": "",
                            "no-local-sorting": ""
                          },
                          on: {
                            "update:busy": function($event) {
                              _vm.isBusy = $event
                            },
                            "sort-changed": _vm.sortChanged,
                            "row-dblclicked": _vm.onRowClicked
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "table-busy",
                                fn: function() {
                                  return [
                                    _c("tables-skeleton", {
                                      attrs: {
                                        fields: _vm.renderedFields,
                                        rows: 3
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "cell(fits)",
                                fn: function(row) {
                                  return [
                                    _c("b-form-checkbox", {
                                      staticClass: "d-inline-block",
                                      attrs: {
                                        checked:
                                          row.item.fits === true ||
                                          row.item.fits === 1 ||
                                          row.item.fits === "true",
                                        disabled: "",
                                        "aria-label": "Подходит по критериям"
                                      },
                                      nativeOn: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    })
                                  ]
                                }
                              },
                              {
                                key: "cell(id)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "b-link",
                                      {
                                        staticClass: "custom-btn-secondary",
                                        staticStyle: {
                                          color: "#1A9167 !important",
                                          "text-decoration": "none !important"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.onRowClicked(row.item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(row.item.id) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(recruit_task_id)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "b-link",
                                      {
                                        staticClass: "custom-btn-secondary",
                                        staticStyle: {
                                          color: "#1A9167 !important",
                                          "text-decoration": "none !important"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showModalRecruitTask(
                                              row.item.recruit_task_id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(row.item.recruit_task_id) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(job_posting_id)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "b-link",
                                      {
                                        staticClass: "custom-btn-secondary",
                                        staticStyle: {
                                          color: "#1A9167 !important",
                                          "text-decoration": "none !important"
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.showModalJobPosting(
                                              row.item.job_posting_id
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(row.item.job_posting_id) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(assigned)",
                                fn: function(row) {
                                  return [
                                    row.item.assigned
                                      ? _c("div", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                _vm.getAssignedName(
                                                  row.item.assigned
                                                )
                                              ) +
                                              "\n              "
                                          ),
                                          _vm.isClaimedByMe(row.item)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "ml-1 custom-tag tag-success"
                                                },
                                                [_vm._v("Вы")]
                                              )
                                            : _vm._e()
                                        ])
                                      : _vm.canEditResponses()
                                      ? _c(
                                          "b-button",
                                          {
                                            staticClass: "custom-btn-primary",
                                            attrs: {
                                              disabled:
                                                _vm.claimingResponseId !== null
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.takeAssignment(
                                                  row.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm.claimingResponseId ===
                                            row.item.id
                                              ? _c("b-spinner", {
                                                  attrs: { small: "" }
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n              Взять\n            "
                                            )
                                          ],
                                          1
                                        )
                                      : _c("span", [_vm._v("—")])
                                  ]
                                }
                              },
                              {
                                key: "cell(worker_id)",
                                fn: function(row) {
                                  return [
                                    row.item.worker_id &&
                                    row.item.worker_active === true &&
                                    _vm.canViewWorkers()
                                      ? _c(
                                          "b-link",
                                          {
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                                return _vm.openWorker(
                                                  row.item.worker_id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(row.item.worker_id) +
                                                "\n            "
                                            )
                                          ]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(
                                                row.item.worker_id || "—"
                                              ) +
                                              "\n              "
                                          ),
                                          row.item.worker_id &&
                                          row.item.worker_active !== true
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "ml-1 custom-tag tag-secondary"
                                                },
                                                [_vm._v("удалён")]
                                              )
                                            : _vm._e()
                                        ])
                                  ]
                                }
                              },
                              {
                                key: "cell(status_id)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          row.item.status_name ||
                                            _vm.getStatusText(
                                              row.item.status_id
                                            )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(start_date)",
                                fn: function(row) {
                                  return [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(
                                          _vm.formatTableDate(
                                            row.item.start_date
                                          )
                                        ) +
                                        "\n          "
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(action)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "b-button-group",
                                      [
                                        row.item.worker_id &&
                                        row.item.worker_active === true &&
                                        _vm.canViewWorkers()
                                          ? _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.top",
                                                    value: {
                                                      title:
                                                        "Создать исполнителя из отклика",
                                                      customClass:
                                                        "custom-tooltip"
                                                    },
                                                    expression:
                                                      "{ title: 'Создать исполнителя из отклика', customClass: 'custom-tooltip' }",
                                                    modifiers: {
                                                      hover: true,
                                                      top: true
                                                    }
                                                  }
                                                ],
                                                staticClass:
                                                  "custom-btn-secondary mr-1",
                                                staticStyle: {
                                                  color: "#1A9167 !important"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.openWorker(
                                                      row.item.worker_id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", {
                                                  attrs: {
                                                    name: "navbar/user_circle",
                                                    size: 13
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.canLinkWorkers() &&
                                        _vm.canProcessResponse(row.item)
                                          ? _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.v-info",
                                                    modifiers: {
                                                      hover: true,
                                                      "v-info": true
                                                    }
                                                  }
                                                ],
                                                staticClass: "mr-1",
                                                attrs: {
                                                  size: "sm",
                                                  variant: "outline-info",
                                                  title:
                                                    "Привязать существующего исполнителя"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.showLinkWorkerModal(
                                                      row.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: { icon: "link" }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.canEditWorkers() &&
                                        _vm.canProcessResponse(row.item)
                                          ? _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.v-info",
                                                    modifiers: {
                                                      hover: true,
                                                      "v-info": true
                                                    }
                                                  }
                                                ],
                                                staticClass: "mr-1",
                                                attrs: {
                                                  size: "sm",
                                                  variant: "info",
                                                  title:
                                                    "Создать исполнителя из отклика"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.showModalWorker(
                                                      row.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("font-awesome-icon", {
                                                  attrs: { icon: "plus" }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.canEditResponses()
                                          ? _c(
                                              "b-button",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-tooltip",
                                                    rawName:
                                                      "v-b-tooltip.hover.v-danger",
                                                    modifiers: {
                                                      hover: true,
                                                      "v-danger": true
                                                    }
                                                  }
                                                ],
                                                staticClass:
                                                  "custom-btn-secondary",
                                                attrs: {
                                                  title: "Удалить отклик"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.onRemove(row)
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-icon", {
                                                  attrs: {
                                                    name: "buttons/trash",
                                                    size: 14
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            554802685
                          )
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-pagination" },
                  [
                    _c("pagination-footer", {
                      attrs: {
                        "use-router": "",
                        "current-page": _vm.currentPage,
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:perPage": function($event) {
                          _vm.perPage = $event
                        },
                        "update:per-page": function($event) {
                          _vm.perPage = $event
                        },
                        "page-click": _vm.onPagination,
                        "per-page-change": _vm.onPerPageChange
                      }
                    })
                  ],
                  1
                )
              ]
            : _c(
                "div",
                { staticClass: "empty-state-container" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [_vm._v("Нет созданных откликов.")]),
                  _vm._v(" "),
                  _c("p", [_vm._v("Создайте новый отклик прямо сейчас")]),
                  _vm._v(" "),
                  _vm.canEditResponses()
                    ? _c(
                        "b-btn",
                        {
                          staticClass: "custom-btn-primary mt-1",
                          attrs: { disabled: _vm.isBusy },
                          on: {
                            click: function($event) {
                              return _vm.showModal(null, false)
                            }
                          }
                        },
                        [
                          _c("v-icon", {
                            staticClass: "mr-1",
                            attrs: { name: "buttons/plus", size: 12 }
                          }),
                          _vm._v("\n        Новый отклик\n      ")
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        2
      ),
      _vm._v(" "),
      _c("DynamicTables", {
        attrs: {
          "storage-key": "jobPostingResponses_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          serviceEndField: _vm.serviceEndField,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      }),
      _vm._v(" "),
      _c("JobPostingResponse", {
        ref: "job_posting_response",
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      }),
      _vm._v(" "),
      _c("recruit-task", {
        ref: "modal_recruit_task",
        attrs: { "is-integrated": true }
      }),
      _vm._v(" "),
      _c("RecruitJobPosting", { ref: "modal_recruit_job_posting" }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal_worker",
          attrs: {
            "body-class": "p-0",
            title: "Создание нового исполнителя",
            size: "xl"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                return [
                  _c(
                    "div",
                    { staticClass: "justify-content-end m-0 p-0" },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1",
                          attrs: { size: "sm", variant: "secondary" },
                          on: {
                            click: function($event) {
                              return _vm.onModalWorkerClosed()
                            }
                          }
                        },
                        [_vm._v("Отмена")]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "success" },
                          on: {
                            click: function($event) {
                              return _vm.handleSubmitModalWorker()
                            }
                          }
                        },
                        [_vm._v("Сохранить")]
                      )
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c("Worker", {
            ref: "worker_component",
            attrs: { "is-modal": true, "response-id": _vm.responseId },
            on: {
              refresh: _vm.onWorkerSaved,
              "close-modal": _vm.onModalWorkerClosed
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal_link_worker",
          attrs: {
            title: "Привязка существующего исполнителя",
            "hide-footer": ""
          },
          on: { hidden: _vm.resetLinkWorkerModal }
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: "ID исполнителя",
                description:
                  "Укажите ID активного исполнителя. Отклик останется закреплён за вами."
              }
            },
            [
              _c("b-form-input", {
                attrs: {
                  type: "number",
                  min: "1",
                  step: "1",
                  disabled: _vm.linkingWorker
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.linkSelectedWorker.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.linkWorkerId,
                  callback: function($$v) {
                    _vm.linkWorkerId = _vm._n($$v)
                  },
                  expression: "linkWorkerId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex justify-content-between align-items-center"
            },
            [
              _vm.canViewWorkers()
                ? _c(
                    "b-link",
                    { attrs: { to: { name: "Workers" }, target: "_blank" } },
                    [_vm._v("\n        Открыть список исполнителей\n      ")]
                  )
                : _c("span"),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mr-1",
                      attrs: {
                        size: "sm",
                        variant: "secondary",
                        disabled: _vm.linkingWorker
                      },
                      on: {
                        click: function($event) {
                          return _vm.$refs.modal_link_worker.hide()
                        }
                      }
                    },
                    [_vm._v("\n          Отмена\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: !_vm.isValidLinkWorkerId || _vm.linkingWorker
                      },
                      on: { click: _vm.linkSelectedWorker }
                    },
                    [
                      _vm.linkingWorker
                        ? _c("b-spinner", { attrs: { small: "" } })
                        : _vm._e(),
                      _vm._v("\n          Привязать\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56e0bf72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56e0bf72","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/JobPostingResponses.vue
// module id = null
// module chunks = 